// extracted by mini-css-extract-plugin
export default {"sponsoredAdsCard":"r4-z","displaySixCardTiles":"s4-z"};